enum EnumTipoAcordoTj {
  DJO = 'DJO',
  ACJ = 'ACJ',
}

export default EnumTipoAcordoTj;
